import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49a3ea9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-page" }
const _hoisted_2 = { class: "show-page" }

import { theme } from '@/store/theme';
import SimpleMode from './SimpleMode.vue';
import ComplexMode from './ComplexMode.vue';
import SubscriptionModal from '../components/SubscriptionModal.vue';
import { globalState } from '@/store/globalState';
import {
  reactive,
  ref,
  onBeforeMount,
  onMounted,
  StyleHTMLAttributes,
  StyleValue,
  watch,
} from 'vue';
import { getLocalConfig, setLocalConfig } from '@/utils/index';
import SideBar from '@/components/SideBar.vue';
import BottomBar from '@/components/BottomBar.vue';
import SettingModal from '@/components/SettingModal.vue';
import CustomMark from '@/components/CustomMark';
import AddComp from '@/components/AddComp';
import AddCategory from '@/components/AddCategory';
import { settings } from '@/store/settings';
import ShareBtn from '@/components/ShareBtn.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HelloWorld',
  setup(__props) {

const editCategroy = ref(null);
const sideBarRef = ref();
const tabConfig = ref({
  chineseCalendar: false,
  calendar: true,
  time: false,
  isSimple: true,
});
const checkedCategories = ref(null);
const sideBarStyle = ref({});
const showSetting = ref(false);
const settingSelected = ref({
  name: '通用',
  value: 'common',
});
const showAdd = ref(false);
const handleAdd = (item) => {
  showAdd.value = true;
  editCategroy.value = item;
};
const getCheckedItem = (item) => {
  checkedCategories.value = item;
};
const refresh = () => {
  sideBarRef.value.refreshCategories();
};
onBeforeMount(() => {
  const config = getLocalConfig('tabConfig');
  if (!config) {
    setLocalConfig('tabConfig', JSON.stringify(tabConfig));
  } else {
    tabConfig.value = JSON.parse(config);
  }
});
const handleEnter = () => {
  if (settings.sideColumn == 1) {
    if (sideBarStyle.value.left === '-100px') {
      sideBarStyle.value = { ...sideBarStyle.value, left: '0px' };
    }
    if (sideBarStyle.value.right === '-100px') {
      sideBarStyle.value = { ...sideBarStyle.value, right: '0px' };
    }
  }
};
const handleLeave = () => {
  if (settings.sideColumn == 1) {
    if (sideBarStyle.value.left === '0px') {
      sideBarStyle.value = { ...sideBarStyle.value, left: '-100px' };
    }
    if (sideBarStyle.value.right === '0px') {
      sideBarStyle.value = { ...sideBarStyle.value, right: '-100px' };
    }
  }
};
const getSideBarStyle = () => {
  return {
    right: settings.sideColumnPosition === 1 ? '0px' : 'auto',
    left: settings.sideColumnPosition === 0 ? '0px' : 'auto',
    // 自动隐藏
    ...(settings.sideColumn == 1
      ? settings.sideColumnPosition === 0
        ? { left: '-100px' }
        : { right: '-100px' }
      : {}),
    ...(settings.sideColumn == 2 && { display: 'none' }),
  } as StyleValue;
};

const showLogin = () => {
  showSetting.value = true;
  settingSelected.value.name = '登录';
  settingSelected.value.value = 'login';
};

const handleSetting = () => {
  showSetting.value = !showSetting.value;
  settingSelected.value.name = '通用';
  settingSelected.value.value = 'common';
};

const hideSubscriptionModal = () => {
  globalState.hideSubscriptionModal();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    style: _normalizeStyle({
      backgroundImage: `url(${
        _unref(settings).wallpaper || require('../background/default_bg.jpg')
      })`,
      transition: 'filter 0.5s ease, background-image 0.5s ease',
      backdropFilter: 'blur(0px)',
    })
  }, [
    _createVNode(ShareBtn),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(SimpleMode, { tabConfig: tabConfig.value }, null, 8, ["tabConfig"])
    ], 512), [
      [_vShow, _unref(settings).isSimple]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(ComplexMode, {
        categorie: checkedCategories.value,
        onShowLogin: showLogin
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "side-bar",
            style: _normalizeStyle({
            right: _unref(settings).sideColumnPosition === 1 ? '0px' : 'auto',
            left: _unref(settings).sideColumnPosition === 0 ? '0px' : 'auto',
          }),
            onMouseleave: handleLeave,
            onMouseenter: handleEnter
          }, [
            (!_unref(settings).isSimple)
              ? (_openBlock(), _createBlock(SideBar, {
                  key: 0,
                  style: _normalizeStyle(sideBarStyle.value),
                  onHandleSetting: handleSetting,
                  onGetCheckedItem: getCheckedItem,
                  onHandleAdd: handleAdd,
                  ref_key: "sideBarRef",
                  ref: sideBarRef
                }, null, 8, ["style"]))
              : _createCommentVNode("", true)
          ], 36)
        ]),
        _: 1
      }, 8, ["categorie"])
    ], 512), [
      [_vShow, !_unref(settings).isSimple]
    ]),
    (showSetting.value)
      ? (_openBlock(), _createBlock(SettingModal, {
          class: "setting-modal",
          onHandleClose: _cache[0] || (_cache[0] = ($event: any) => (showSetting.value = false)),
          key: "setting",
          selected: settingSelected.value
        }, null, 8, ["selected"]))
      : _createCommentVNode("", true),
    (showAdd.value)
      ? (_openBlock(), _createBlock(_unref(AddCategory), {
          key: 1,
          class: "add-category",
          onRefresh: refresh,
          onHandleClose: _cache[1] || (_cache[1] = ($event: any) => (showAdd.value = false)),
          detail: editCategroy.value
        }, null, 8, ["detail"]))
      : _createCommentVNode("", true),
    (_unref(globalState).isShowSubscription)
      ? (_openBlock(), _createBlock(SubscriptionModal, {
          key: 2,
          onHandleClose: hideSubscriptionModal
        }))
      : _createCommentVNode("", true)
  ], 4))
}
}

})